exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#srp-preview{position:relative}#preview .preview-list .v-list__tile:before{content:\"\";height:2px;width:8px;margin-right:10px}#preview .preview-list{-webkit-box-shadow:1px 1px 10px 5px rgba(0,0,0,.1);box-shadow:1px 1px 10px 5px rgba(0,0,0,.1);border-radius:4px}", ""]);

// exports
